module.exports = __webpack_public_path__ + "review.825c6999.png";